import { env } from '@/lib/env';

/** Defaults for Job Failure local stack (override via REACT_APP_* in .env.development.local). */
export const DEFAULT_SAP_SYSTEM = env('REACT_APP_SAP_JOB_DEFAULT_SYSTEM') || 'S4H';
export const DEFAULT_SAP_CLIENT = env('REACT_APP_SAP_JOB_DEFAULT_CLIENT') || '100';

export const SAP_JOB_LIST_POLL_MS = 45_000;
export const SAP_JOB_DETAIL_POLL_MS = 20_000;
export const SAP_JOB_MONITORED_PAGE_SIZE = 50;
export const SAP_JOB_UPCOMING_PAGE_SIZE = 200;

/** Default Finished view: last N UTC calendar days through today. */
export const SAP_JOB_DEFAULT_FINISHED_LOOKBACK_DAYS = 7;

export function defaultFinishedExecutionDateRange(referenceDate = new Date()) {
  const end = new Date(
    Date.UTC(
      referenceDate.getUTCFullYear(),
      referenceDate.getUTCMonth(),
      referenceDate.getUTCDate(),
    ),
  );
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - (SAP_JOB_DEFAULT_FINISHED_LOOKBACK_DAYS - 1));
  const fmt = (d) => d.toISOString().slice(0, 10);
  return { from: fmt(start), to: fmt(end) };
}

/** Inclusive calendar from/to (YYYY-MM-DD) → UTC actual_start window [from, next day after to). */
export function executionDateRangeParams(fromDate, toDate) {
  const from = (fromDate || '').trim();
  const to = (toDate || '').trim();
  if (!from && !to) return {};
  const startDay = from || to;
  const endDay = to || from;
  const endExclusive = new Date(`${endDay}T00:00:00.000Z`);
  endExclusive.setUTCDate(endExclusive.getUTCDate() + 1);
  return {
    from_datetime: `${startDay}T00:00:00.000Z`,
    to_datetime: endExclusive.toISOString(),
  };
}
